import { updateTranslations, updateTranslationsRemote } from './actions';
import immerHandleActions from 'redux/utils/immerHandleActions';
import labelsEn from './labelsEn.json';
import labelsAr from './labelsAr.json';
import Cookies from 'js-cookie';

const init: types.redux.dynamicLabels.State = {};
const languageCookie = 'com.ibm.wps.state.preprocessors.locale.LanguageCookie';
const reducers = {
	[updateTranslations]: (state: types.redux.dynamicLabels.State, action: any) => {
		return action.payload === 'en' ? labelsEn : labelsAr;
	},
	[updateTranslationsRemote]: (state: types.redux.dynamicLabels.State, action: any) => {
		return action.payload;
	},
	'persist/REHYDRATE': (state: string, { payload = {} }) => {
		// @ts-ignore
		const { settings = {} } = payload;
		let { language = 'en' } = settings;
		const cookieLang = Cookies.get(languageCookie);
		if (cookieLang) {
			language = cookieLang;
		}
		return language === 'en' ? labelsEn : labelsAr;
	},
};
export default immerHandleActions(reducers, init);
